import * as React from 'react';
import { useLayoutEffect } from 'react';
import './App.module.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import MainPage from './main/MainPage/MainPage';
import LoginPage from './login/LoginPage';
import CreateTopic from "./editor/createTopic";
import EditTopic from "./editor/EditTopic";
import { api } from "./utils/useAxios";
import { useDataDogIdentifyUser } from "./utils/data-dog";

const App = () => {
    return (
        <>
            <AddAuthHeaders />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/health" element={<h3>Health Check</h3>} />
                    <Route path="/editor/create" element={
                        <PrivateRoute>
                            <CreateTopic />
                        </PrivateRoute>
                    } />
                    <Route path="/editor/edit" element={
                        <PrivateRoute>
                            <EditTopic csvData={[]} data={[]} pickedStates={[]} />
                        </PrivateRoute>
                    } />
                    <Route path="/app" element={
                        <PrivateRoute>
                            <MainPage />
                        </PrivateRoute>
                    } />
                </Routes>
            </BrowserRouter>
        </>
    );
};

function AddAuthHeaders() {
    const { getAccessTokenSilently, isLoading } = useAuth0();

    useDataDogIdentifyUser();

    useLayoutEffect(() => {
        if (isLoading) return;

        const addAuthHeader = async (config) => {
            const apiToken = await getAccessTokenSilently();
            config.headers = config.headers || {};
            config.headers.Authorization = "Bearer " + apiToken;
            return config;
        };

        api.interceptors.request.use(addAuthHeader);

    }, [isLoading, getAccessTokenSilently]);

    return null;
}

function PrivateRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth0();

    if (isLoading) {
        return null;
    }

    return isAuthenticated ? children : <Navigate to="/" replace />;
}

export default App;
